export const PLATFORM_TO_PROVIDER: Record<string, string> = {
  chatgpt: "GPT",
  perplexity: "PERP",
  "ai-overviews": "GOOGLE_OVERVIEW",
  "ai-mode": "AI_MODE",
  gemini: "GEMINI",
  grok: "GROK",
  copilot: "COPILOT",
};

export const PROVIDER_TO_PLATFORM: Record<string, string> = Object.entries(
  PLATFORM_TO_PROVIDER,
).reduce<Record<string, string>>((acc, [platform, provider]) => {
  acc[provider.toUpperCase()] = platform;
  return acc;
}, {});

export const mapPlatformsToProviders = (
  platforms?: string[],
): string[] | undefined => {
  if (!platforms?.length) return undefined;
  const mapped = platforms
    .map((platform) => String(platform || "").trim().toLowerCase())
    .filter(Boolean)
    .map((platform) => PLATFORM_TO_PROVIDER[platform] || platform.toUpperCase());
  if (!mapped.length) return undefined;
  return Array.from(new Set(mapped));
};

export const mapProvidersToPlatforms = (
  providers?: string[],
): string[] | undefined => {
  if (!providers?.length) return undefined;
  const mapped = providers
    .map((provider) => String(provider || "").trim().toUpperCase())
    .filter(Boolean)
    .map((provider) => PROVIDER_TO_PLATFORM[provider] || provider.toLowerCase());
  if (!mapped.length) return undefined;
  return Array.from(new Set(mapped));
};

